import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Environment, EnvironmentName, EnvironmentType } from 'dashboard/models/environment';
import { RootState } from 'dashboard/redux/store';

/**
 * @name `useCurrentEnvironmentType`
 *
 * A hook that returns the current environment type and display name.
 *
 */
export default (): { type: EnvironmentType; name: EnvironmentName } => {
  const currentEnvironment = useSelector<RootState, Environment>(
    (state) => state.currentEnvironment.currentEnvironment,
  );

  return useMemo(() => {
    return {
      type: currentEnvironment?.type,
      name: currentEnvironment?.attributes?.name,
    };
  }, [currentEnvironment]);
};
